// const { Storage } = Plugins;

import React from "react";
import { HeaderHomeBar } from "./localStyle";
import { useHistory } from "react-router";

const HeaderTitle = ({ title, subtitle }) => {
  const history = useHistory();

  const onClickBack = () => {
    if (window.history.length > 1) {
      history.goBack(); // Va 1 página atrás
    } else {
      history.push("/autocheckin");
    }
  };

  return (
    <React.Fragment>
      <HeaderHomeBar
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          opacity: [0, 0.3, 0.7, 1],
          times: [0, 0.3, 0.7, 1],
        }}
      >
        <span className="arrow" onClick={onClickBack}>
          {"<"}
        </span>
        <span className="title">{title}</span>
        <span className="title-pregunta">{subtitle}</span>
      </HeaderHomeBar>
    </React.Fragment>
  );
};

export default HeaderTitle;
